import React from 'react';
import { Grid, Button } from '@material-ui/core';

export const BackButton: React.FC = () => {
    return <Grid item container direction="row" justify="flex-start">
        <Grid item>
            <Button variant="outlined" color="secondary" onClick={() => window.history.go(-1)}>Natrag</Button>
        </Grid>
    </Grid>
}